import React, { useState } from 'react';
import { AmazonPriceSetterScreen } from '../../screens/AmazonPriceSetter/AmazonPriceSetterScreen';
import axios from 'axios';

export function AmazonPriceSetter() {
  const [inputContents, setInputContents] = useState('');
  const [amazonReportContents, setAmazonReportContents] = useState('');
  const [outputContents, setOutputContents] = useState([]);
  const [processing, setProcessing] = useState(false)

  const onInputData = (e) => {
    setInputContents(e.target.value);
  };

  const onInputAmazonReport = (e) => {
    setAmazonReportContents(e.target.value);
  };

  const onClickConfirm = () => {
    if (!Boolean(amazonReportContents) || !Boolean(inputContents)) {
      return alert('You must enter data in both boxes');
    }
    setProcessing(true)
    axios
      .post(process.env.REACT_APP_HOST + 'getAmazonData', {
        params: {
          inputData: inputContents,
          amazonReportContents: amazonReportContents,
        },
      })
      .then((res) => {
        console.log(res)
        setProcessing(false)
        setOutputContents(res.data);
      })
      .catch((err) => {
        console.log(err);
        setProcessing(false)
      });
  };

  return (
    <AmazonPriceSetterScreen
      onInputData={onInputData}
      inputContents={inputContents}
      amazonReportContents={amazonReportContents}
      onInputAmazonReport={onInputAmazonReport}
      onClickConfirm={onClickConfirm}
      outputContents={outputContents}
      processing={processing}
    />
  );
}
